import { computed, type Ref } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import { toNumber } from 'lodash'
import { useListMetricAssignmentsQuery } from '~/types/types'

/** Metric rows + venture + starting year for GHG growth-factor KPI (1216) on current solution. */
export function useGhgGrowthFactorAssignments(
  impactData: Ref<Record<string, any> | undefined>,
  impactGoalData: Ref<Record<string, any> | undefined>,
  impactSolutionData: Ref<Record<string, any> | undefined>,
) {
  const route = useRoute()
  const ventureId = computed(() => String(route.params.venture ?? ''))
  const impactSolutionIndex = computed(() => toNumber(route.params.solution))

  const impactSolution = computed(
    () =>
      impactSolutionData.value ||
      impactData.value?.impactSolutions?.[impactSolutionIndex.value],
  )

  const ghgSavingPotentialId = computed(() => impactSolution.value?.ghgSavingPotential?.id)

  const { result } = useListMetricAssignmentsQuery({
    limit: 1000,
    assigneeIds: [ventureId.value],
    ghgSavingPotentialId,
    metricNotionIds: ['4b017bded5fb4253bd6927c1c662ea12'],
  })

  const metricAssignments = computed(
    () =>
      result.value?.listMetricAssignments?.filter(
        (a) => a.ghgSavingPotentialId === ghgSavingPotentialId.value,
      ) ?? [],
  )

  const ghgStartingYear = computed(() => {
    const v = Number(impactData.value?.startingYear ?? impactGoalData.value?.ghgStartingYear)
    return Number.isFinite(v) ? v : new Date().getFullYear()
  })

  return { ventureId, metricAssignments, ghgStartingYear, ghgSavingPotentialId }
}
